import React from "react";
import { ImageDataLike } from "gatsby-plugin-image";
import { IContentfulImage } from "../../../types/IContentfulImage";
import { LenderPanel } from "../../../components/panels/LenderPanel";
import { IModule } from "../types";
import { IContentfulRichTextResponse } from "../../../types/IContentfulRichText";

export type GetLenderPanelProps = IModule<{
  title: string,
  subtitleRichText: IContentfulRichTextResponse,
  images: IContentfulImage[] & ImageDataLike[]
}>
export const getLenderPanel: React.FC<GetLenderPanelProps> = ({
  title, subtitleRichText, images,
}) => (
  <LenderPanel
    title={title}
    subtitleRichText={subtitleRichText}
    images={images}
  />
);
